var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PartialRenderer',{attrs:{"items":_vm.getHosts,"force-render-items":"5"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
var index = ref.index;
return [_c('host-item',{attrs:{"host-index":index,"host":item}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }